import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Stack,
    Alert,
    Link,
    useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../../api/authAPI";

export default function ResetPassword() {
    const theme = useTheme();
    const navigate = useNavigate();

    const [form, setForm] = useState({
        email: "",
        code: "",
        newPassword: "",
    });

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    console.log(error,"error")

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        try {
            const response = await resetPassword(
                form.email,
                form.code,
                form.newPassword
            );

            console.log(response, "reset response");
            if (response.data == 'SUCCESS') {
                setMessage("Password has been reset successfully!");
                setTimeout(() => navigate("/login"), 1500);
            }
            else if(response.data=='CodeMismatchException'){
                setError("code mismatched")
            }
            else{
                setError("something went wrong")
            }

        } catch (err) {
            console.error(err);
            setError("Invalid code or password. Please try again.");
        }
    };

    return (
        <Box>
            {/* Logo */}
                  <Box textAlign="center" mb={3}>
                    <Box
                      component="img"
                      src="/csepathshala.png"
                      alt="Topperhub"
                      sx={{
                        height: 56,
                        mb: 1,
                        filter:
                          theme.palette.mode === "dark"
                            ? "brightness(1.1)"
                            : "none",
                      }}
                    />
                  </Box>
            <Typography
                variant="h4"
                textAlign="center"
                fontWeight={500}
                mb={3}
                color={theme.palette.text.primary}
            >
                Reset Password
            </Typography>

            <Typography
                textAlign="center"
                mb={4}
                color={theme.palette.text.secondary}
            >
                Enter your verification code & new password
            </Typography>

            <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                    <TextField
                        label="Email"
                        fullWidth
                        value={form.email}
                        onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                        }
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                    />

                    <TextField
                        label="Verification Code"
                        fullWidth
                        value={form.code}
                        onChange={(e) =>
                            setForm({ ...form, code: e.target.value })
                        }
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                    />

                    <TextField
                        label="New Password"
                        type="password"
                        fullWidth
                        value={form.newPassword}
                        onChange={(e) =>
                            setForm({ ...form, newPassword: e.target.value })
                        }
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            borderRadius: "12px",
                            paddingY: 1.2,
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "16px",
                            color: theme.palette.primary.contrastText,
                        }}
                    >
                        Reset Password
                    </Button>

                    {message && (
                        <Alert severity="success" sx={{ borderRadius: "10px" }}>
                            {message}
                        </Alert>
                    )}

                    {error && (
                        <Alert severity="error" sx={{ borderRadius: "10px" }}>
                            {error}
                        </Alert>
                    )}

                    <Typography textAlign="center" mt={1} color={theme.palette.text.secondary}>
                        Back to{" "}
                        <Link
                            underline="none"
                            sx={{ cursor: "pointer", color: theme.palette.primary.main }}
                            onClick={() => navigate("/login")}
                        >
                            Login
                        </Link>
                    </Typography>
                </Stack>
            </form>
        </Box>
    );
}
